import Head from 'next/head'
import { usePathname } from 'next/navigation'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import styled from 'styled-components'
import AppFooter from '@/components/public-page/footer'
import AppHeader from '@/components/public-page/header'
import defaultMetaInfo, {
  defaultTitlePrefix,
} from '@/constants/landing/default-meta-info'
import useHeaderHeight from '@/hooks/use-header-height'
import { useI18n } from '@/hooks/use-i18n'
import ogImgSrc from '@/public/assets/images/og-img.png'
import env from '@/utils/env'

const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const pathname = usePathname()
  const { language } = useI18n()
  const headerHeight = useHeaderHeight()

  const currentPageUrl = `${env.LANDING_URL}${pathname}`

  return (
    <>
      <Head>
        <title>
          {defaultTitlePrefix + defaultMetaInfo[language.i18nCode].title}
        </title>
        <link href={currentPageUrl} rel='canonical' />
        <meta content={ogImgSrc} property='og:image' />
        <meta content='285' property='og:image:width' />
        <meta content='150' property='og:image:height' />
      </Head>
      <AppHeader />
      <PageContainer $headerHeight={headerHeight}>{children}</PageContainer>
      <AppFooter />
    </>
  )
}

const PageContainer = styled.div<{ $headerHeight: number }>`
  margin-top: ${({ $headerHeight }): number => $headerHeight}px;
`

export default Layout
